import React, { useState } from "react";
// import AddMultipleLinkModal from "../Campaigns/AddMultipleLinkModal";

const SetupInstructions = () => {
  const steps = [
    {
      id: 1,
      title: "Insert tracking code",
      icon: `${process.env.PUBLIC_URL}/Icons/campaign/homeIcon.PNG`,
      width: "40",
      component: <InsertTrackingCode />,
    },

    {
      id: 2,
      title: "Connect the billing platform",
      icon: `${process.env.PUBLIC_URL}/Icons/campaign/rewardIcon.PNG`,
      width: "40",
      component: <ConnectionBillingPlatform />,
    },
    {
      id: 3,
      title: "Test the tracking and integration",
      icon: `${process.env.PUBLIC_URL}/Icons/campaign/advance.PNG`,
      width: "40",
      component: <TestTrackingAndIntegration />,
    },
  ];

  const [currentStep, setCurrentStep] = useState(1);

  return (
    <div>
      {/* <AddMultipleLinkModal /> */}
      <h1 className="font-bold text-2xl uppercase text-gray-500 pb-10">
        My Profile and setting
      </h1>
      <div className="bg-white lg:w-[90%] w-full mx-auto lg:mt-20 mt-2">
        <h1 className="py-5 px-5 border-b-2 font-semibold text-secondary">
          Quick setup
        </h1>
        <div className="flex justify-evenly gap-5">
          {steps.map((step, i) => (
            <div
              key={i}
              onClick={() => setCurrentStep(step.id)}
              className="flex flex-col items-center lg:px-10 px-2 py-5 cursor-pointer"
            >
              <h1
                className={` rounded-full ${
                  i === 0 ? "px-5" : "px-5"
                } py-2 text-white text-2xl 
                ${i + 1 === currentStep ? "bg-primary" : "bg-gray-200"}
                `}
              >
                {i + 1}
              </h1>
              <h1 className="md:text-sm mt-3 text-accent text-xs ">
                {step.title}
              </h1>
            </div>
          ))}
        </div>
        {steps[currentStep - 1]?.component}
        <div className="flex justify-end bg-gray-100 border-t-2 py-3 px-5 ">
          {(currentStep === 2 || currentStep === 3) && (
            <button
              disabled={currentStep > 3}
              onClick={() => setCurrentStep((p) => p - 1)}
              className="px-5 py-2 border-2 bg-white text-secondary rounded-md mr-3"
            >
              Previous
            </button>
          )}
          {currentStep < 3 && (
            <button
              disabled={currentStep > 3}
              onClick={() => setCurrentStep((p) => p + 1)}
              className="px-5 py-2 border-2 bg-primary text-white rounded-md"
            >
              Next
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SetupInstructions;

const InsertTrackingCode = () => {
  return (
    <div className="py-5 text-accent">
      <div className="mb-5 border-t pb-5"></div>
      <div className="px-5">
        <p>
          Click on the button below to view the instructions of how to insert
          the tracking code into your website. It shouldn't take more than 10
          minutes. You can also send the instructions to your developer by
          email.
        </p>
        <p className="mt-5">
          If you are using ClickFunnels with Stripe, no developer is required.
          Please follow{" "}
          <span className="text-blue-500 cursor-pointer">
            these instructions{" "}
          </span>{" "}
          instead.
        </p>
      </div>
      <div className="flex justify-center">
        <button className="px-5 py-2 bg-fuchsia-500 rounded-full my-7 text-white">
          View instructions
        </button>
      </div>
      <p className="pb-5 px-5">
        Your developer can see the instructions even if he's not logged in, but
        we recommend to{" "}
        <span className="text-blue-500 cursor-pointer">invite him</span> (at
        least temporary) to your FirstPromoter team to test the integration.
      </p>
      <div className="mx-5 relative mb-10">
        <input
          className="w-full px-7 py-2.5 border border-gray-400 "
          type="text"
          name=""
          id=""
        />
        <button
          className="px-7 py-3 bg-primary text-white absolute top-0 right-0"
          htmlFor=""
        >
          Send instruction
        </button>
      </div>
    </div>
  );
};

const ConnectionBillingPlatform = () => {
  return (
    <div className="py-5 text-accent">
      <div className="mb-5 border-t pb-5"></div>
      <div className="px-5">
        <p>
          The following integration will allow us to safely track the actual
          sales generated by promoters. Your promoters will get rewarded only
          when you get paid.
        </p>
        <p className="mt-5">
          If you can't find your provider below,{" "}
          <span className="text-blue-500 cursor-pointer">click here</span> to
          connect using our tracking API.
        </p>
        <p className="mt-5">
          Please click on your billing provider to select it:
        </p>
        <div className="grid md:grid-cols-4 grid-cols-2 gap-10 mt-5 mb-10">
          {["stripe", "braintree", "recurly", "chargebee"].map((img) => (
            <div key={img} className="w-32 border-2 p-5 ">
              <img
                className="w-32"
                src={`${process.env.PUBLIC_URL}/Icons/${img}.PNG`}
                alt=""
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const TestTrackingAndIntegration = () => {
  return (
    <div className="py-5 text-accent">
      <div className="mb-5 border-t pb-5"></div>
      <div className="px-5">
        <h1 className="text-secondary font-bold">Test visitors tracking</h1>
        <p className="my-3">
          Open a browser window in the incognito/private mode and go the URL
          below. If you added the tracking code to a different website, append
          "#_r_testvy8dz3u2" to it.
        </p>
        <input
          className="w-full px-5 py-2 bg-gray-200"
          type="text"
          name=""
          id=""
        />
        <p className="text-center mx-5 mt-5">
          After you visit the test url, wait a few seconds and click on the
          following button. Do not close the browser after this!
        </p>
        <div className="flex justify-center">
          <button className="px-5 py-2 bg-primary rounded my-7 text-white">
            Test visitors tracking
          </button>
        </div>
        <p className="text-center mx-5 ">
          After you visit the test url, wait a few seconds and click on the
          following button. Do not close the browser after this!
        </p>
        <div className="flex justify-center">
          <button className="px-5 py-2 bg-fuchsia-500 rounded my-7 text-white">
            Finish
          </button>
        </div>
      </div>
    </div>
  );
};
